import http from '../utils/http'

// 内容列表
export function listAPI(data) {
    return http.post('/article/list', data)
}

// 圈子数据管理
export function forumDataAPI() {
    return http.post('/select/forumData')
}

// 内容详情
export function getarticledetailAPI(data) {
    return http.post('/article/getarticledetail', data)
}

// 评论列表
export function showCommentListAPI(params) {
    return http.get('/article/showCommentList', params)
}

// 删除评论
export function deleteCommentListAPI(data, params) {
    return http.post('/article/showCommentList', data, params)
}

// 评论
export function addCommentListAPI(data, params) {
    return http.post('/article/showCommentList', data, params)
}

// 审批
export function doauditAPI(data) {
    return http.post('/article/doaudit', data)
}

// 推荐
export function setRecommendAPI(data, params) {
    return http.post('/article/setRecommend', data, params)
}

// 投诉专区
export function editforumAPI(data) {
    return http.post('/article/editforum', data)
}

// 创单
export function pushWorkOrderAPI(data, params) {
    return http.post('/article/pushWorkOrder', data, params)
}